import SetupRmDayabaySmsModal from './setup-rm-dayabay-sms-modal.vue'
export default SetupRmDayabaySmsModal
